// @ts-nocheck
export function getDashboardTitle(pathname) {
  const map = {
    '/': 'Home',
    '/home': 'Home',
    '/copilot': 'Copilot',
    '/copilot-2': 'Copilot',
    '/get-support': 'Support',
    '/support-tickets': 'Support tickets',
    '/change-requests': 'Change requests',
    '/feature-requests': 'Feature Voting',
    '/release-notes': 'Change Log',
    '/discover-addons': 'Add-on services',
    '/profile': 'My profile',
    '/early-adopters': 'Early Adopters',
    '/my-subscription': 'My Subscription',
    '/resources/knowledge-base': 'Knowledge Base',
    '/knowledge-base-2': 'Knowledge Base',
    '/resources/university': 'AvSight University',
    '/login': 'Sign in',
  };
  if (map[pathname]) return map[pathname];
  if (pathname.startsWith('/resources/embed')) return 'Linked content';
  return '';
}
